import router from '@/router';
import { startupLocation } from '@/router/redirect';
import { ROUTE_NAMES } from '@/router/routeNames';

let unauthorizedPromise: Promise<void> | null = null;

export function handleUnauthorized (): Promise<void> {
  if (!unauthorizedPromise) {
    unauthorizedPromise = runUnauthorized().finally(() => {
      unauthorizedPromise = null;
    });
  }

  return unauthorizedPromise;
}

async function runUnauthorized (): Promise<void> {
  // Lazy import: auth store → api client → this module.
  const { useAuthStore } = await import('@/stores/auth');
  useAuthStore().clearAuth();

  const current = router.currentRoute.value;
  if (current.name !== ROUTE_NAMES.STARTUP) {
    await router.push(startupLocation(current.fullPath)).catch(() => {});
  }
}
